import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {SettingActiveContractorPage} from "../setting-active-contractor/setting-active-contractor";
import {SettingAdvancedPage} from "../setting-advanced/setting-advanced";
import {SettingCertificatePage} from "../setting-certificate/setting-certificate";
import {SettingRemarksPage} from "../setting-remarks/setting-remarks";
import {SettingNotesPage} from "../setting-notes/setting-notes";
import {Subscription} from "rxjs/Subscription";
import {SettingDatabaseImportPage} from "../setting-database-import/setting-database-import";
import {GlobalProvider} from "../../providers/global/global";
import {SettingTeamInvitationPage} from "../setting-team-invitation/setting-team-invitation";
import {SettingPersonalDataPage} from "../setting-personal-data/setting-personal-data";
import {blobToDataURL} from "blob-util";
import {SettingService} from "../../store/setting/setting.service";
import {ContactService} from "../../store/contact/contact.service";
import {ContactEntity} from "../../store/contact/contact.entity";

/**
 * Generated class for the SettingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-setting',
  templateUrl: 'setting.html',
})
export class SettingPage {

  public activeContractor: ContactEntity;
  public isBrowser: boolean = false;

  private settings: any;
  private _customerSubscription: Subscription;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private dataProvider: DataProvider,
              private contactService: ContactService,
              private globalProvider: GlobalProvider,
              private settingService: SettingService) {
    this.isBrowser = this.globalProvider.isBrowser();
  }

  ionViewWillEnter() {

    this._customerSubscription = this.settingService.get()
      .map((settingDocument) => {
        console.dir(settingDocument)
        this.settings = settingDocument;
        return settingDocument;
      })
      .flatMap(settingDocument => this.contactService.getById(settingDocument.activeContractor))
      .subscribe((activeContractor: ContactEntity) => {
        if (activeContractor) {
          this.activeContractor = activeContractor;

          if (activeContractor._attachments) {
            let logoAttachmentName = null;
            for (let attachmentName in activeContractor._attachments) {
              if (attachmentName.indexOf('logo') !== -1) {
                logoAttachmentName = attachmentName;
                break;
              }
            }
            if (logoAttachmentName) {
              this.dataProvider.getAttachment(activeContractor._id, logoAttachmentName)
                .then((logo) => {
                  blobToDataURL(logo)
                    .then((base64) => {
                      activeContractor.logo = base64;
                    })
                })
            }
          }
        }
      })

    // this._customerSubscription = this.dataProvider.getObservDocumentById(this.globalProvider.user.uuid)
    //   .map((settingDocument) => {
    //     console.dir(settingDocument)
    //     this.settings = settingDocument;
    //     return settingDocument;
    //   })
    //   .flatMap(settingDocument => this.customerProvider.getById(settingDocument.activeContractor))
    //   .subscribe((activeContractor) => {
    //     if (activeContractor !== null) {
    //       this.activeContractor = activeContractor;
    //
    //       if (activeContractor._attachments) {
    //         let logoAttachmentName = null;
    //         for (let attachmentName in activeContractor._attachments) {
    //           if (attachmentName.indexOf('logo') !== -1) {
    //             logoAttachmentName = attachmentName;
    //             break;
    //           }
    //         }
    //         if (logoAttachmentName) {
    //           this.dataProvider.getAttachment(activeContractor._id, logoAttachmentName)
    //             .then((logo) => {
    //               blobToDataURL(logo)
    //                 .then((base64) => {
    //                   activeContractor.logo = base64;
    //                 })
    //             })
    //         }
    //       }
    //     }
    //   })
  }

  ionViewWillLeave() {
    this._customerSubscription.unsubscribe();
  }

  public openAvailableContractor(): void {
    this.navCtrl.push(SettingActiveContractorPage, {settings: this.settings});
  }

  public openAdvancedSettings(): void {
    this.navCtrl.push(SettingAdvancedPage, {settings: this.settings});
  }

  public openCertificatePage(): void {
    this.navCtrl.push(SettingCertificatePage, {settings: this.settings});
  }

  public openRemarkTemplates(): void {
    this.navCtrl.push(SettingRemarksPage);
  }

  public openNoteTemplate(): void {
    this.navCtrl.push(SettingNotesPage);
  }

  public openSettingsDatebaseImport(): void {
    this.navCtrl.push(SettingDatabaseImportPage)
  }

  public openTeamInvitationPage(): void {
    this.navCtrl.push(SettingTeamInvitationPage);
  }

  public openPersonalData(): void {
    this.navCtrl.push(SettingPersonalDataPage, {settings: this.settings});
  }
}



// WEBPACK FOOTER //
// ./src/pages/setting/setting.ts